import React from 'react';
import { Container, Row, Col, Card, Table } from 'react-bootstrap';
import { Bar, Pie, Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import 'bootstrap-icons/font/bootstrap-icons.css';
import NavBar from './Navbar';

// Register necessary Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  ArcElement,
  Title,
  Tooltip,
  Legend
);

export default function Dashboard({onLogout, user }) {
  // Comprehensive dummy stats
  const stats = {
    totalPayrolls: 12,
    totalRecords: 5421,
    totalErrors: 18,
    employeeCount: 312,
    averageAmountPerPayroll: 4500,
    departmentCount: 5,
    byDepartment: [
      { name: 'DCG', total: 18000 },
      { name: 'NCG', total: 15000 },
    
    ],
    statusDistribution: [
      { status: 'Completed', count: 4000 },
      { status: 'Pending', count: 800 },
      { status: 'Error', count: 621 },
    ],
    monthlyTrend: [
      { month: 'Jan', records: 800 },
      { month: 'Feb', records: 950 },
      { month: 'Mar', records: 700 },
      { month: 'Apr', records: 1200 },
      { month: 'May', records: 1000 },
      { month: 'Jun', records: 771 },
    ],
    recentRuns: [
      { id: 'P012', date: '2025-06-10', amount: '$5,200', status: 'Completed' },
      { id: 'P011', date: '2025-06-03', amount: '$4,800', status: 'Pending' },
      { id: 'P010', date: '2025-05-27', amount: '$4,950', status: 'Error' },
      { id: 'P009', date: '2025-05-20', amount: '$5,100', status: 'Completed' },
      { id: 'P008', date: '2025-05-15', amount: '$4,700', status: 'Completed' },
    ],
  };

  // Chart datasets
  const barData = {
    labels: stats.byDepartment.map(d => d.name),
    datasets: [
      {
        label: 'Total Amount',
        data: stats.byDepartment.map(d => d.total),
        backgroundColor: 'rgba(54,162,235,0.6)',
      },
    ],
  };

  const pieData = {
    labels: stats.statusDistribution.map(s => s.status),
    datasets: [
      {
        data: stats.statusDistribution.map(s => s.count),
        backgroundColor: ['#3e95cd', '#8e5ea2', '#e8c3b9'],
      },
    ],
  };

  const lineData = {
    labels: stats.monthlyTrend.map(m => m.month),
    datasets: [
      {
        label: 'Records Processed',
        data: stats.monthlyTrend.map(m => m.records),
        fill: false,
        tension: 0.3,
        borderColor: 'rgba(75,192,192,1)',
      },
    ],
  };

  return (
    <>
    <NavBar user={user} onLogout={onLogout} />
    <Container fluid className="py-4">
      

      {/* Summary Cards */}
      <Row className="g-3 mb-4">
        {[
          { icon: 'card-list', label: 'Total Payrolls', value: stats.totalPayrolls, color: 'primary' },
          { icon: 'table', label: 'Processed Records', value: stats.totalRecords, color: 'success' },
          { icon: 'exclamation-triangle', label: 'Errors', value: stats.totalErrors, color: 'danger' },
          { icon: 'people', label: 'Employees', value: stats.employeeCount, color: 'warning' },
          { icon: 'calculator', label: 'Avg Amount/Payroll', value: `$${stats.averageAmountPerPayroll}`, color: 'info' },
          { icon: 'building', label: 'Departments', value: stats.departmentCount, color: 'secondary' },
        ].map((card, idx) => (
          <Col key={idx} md={4} lg={2} sm={6} xs={12}>
            <Card className="shadow-sm text-center py-3">
              <i className={`bi bi-${card.icon} fs-1 text-${card.color}`}></i>
              <h6 className="mt-2">{card.label}</h6>
              <h3>{card.value}</h3>
            </Card>
          </Col>
        ))}
      </Row>

      {/* Charts Section */}
      <Row className="g-3 mb-4">
        <Col lg={4} md={12}>
          <Card className="shadow-sm p-3 h-100">
            <h5 className="mb-3">Department Totals</h5>
            <Bar data={barData} options={{ responsive: true }} />
          </Card>
        </Col>
        <Col lg={4} md={12}>
          <Card className="shadow-sm p-3 h-100">
            <h5 className="mb-3">Run Status</h5>
            <Pie data={pieData} options={{ responsive: true }} />
          </Card>
        </Col>
        <Col lg={4} md={12}>
          <Card className="shadow-sm p-3 h-100">
            <h5 className="mb-3">Monthly Trend</h5>
            <Line data={lineData} options={{ responsive: true }} />
          </Card>
        </Col>
      </Row>

      {/* Recent Payroll Runs Table */}
      <Card className="shadow-sm">
        <Card.Header>
          <h5 className="mb-0">Recent Payroll Runs</h5>
        </Card.Header>
        <Card.Body className="p-0">
          <Table striped hover responsive className="mb-0">
            <thead className="bg-light">
              <tr>
                <th>ID</th>
                <th>Date</th>
                <th>Amount</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {stats.recentRuns.map((run) => (
                <tr key={run.id}>
                  <td>{run.id}</td>
                  <td>{run.date}</td>
                  <td>{run.amount}</td>
                  <td>{run.status}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Card.Body>
      </Card>
    </Container>
    </>
  );
}
